import { createSlice } from "@reduxjs/toolkit";
import { getAds } from "../../thunks/common-thunks/commonThunk";

const initialState = {
    isAdsLoading : false,
    adsList : [],
    error : null
}
export const adsSlice = createSlice({
    name :'ads',
    initialState,
    reducers: {},
    extraReducers: (builder) =>{
        builder
        .addCase(getAds.pending, (state) =>{
            state.isAdsLoading = true;
            state.error = null;
        })
        .addCase(getAds.fulfilled, (state,action) =>{
            state.isAdsLoading = false;
            state.adsList = action.payload;
        })
        .addCase(getAds.rejected, (state,action) =>{
            state.isAdsLoading = false;
            state.error = action.payload;
        })
    }
}) 

export default adsSlice.reducer